import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a9c863e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photovoltaik-support-card solar-page-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Förderung Ihrer Anlage ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Zur Finanzierung Ihrer Photovoltaikanlage besteht die Möglichkeit, einen KfW Förderkredit in Anspruch zu nehmen. Alle weiteren Informationen finden Sie direkt hier bei der KfW. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, " Was wird gefördert? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Errichtung, Erweiterung und Erwerb von Anlagen zur Nutzung erneuerbarer Energien einschließlich der zugehörigen Kosten für Planung, Projektierung und Installation. Die Anlagen müssen den Anforderungen des Gesetzes für den Ausbau erneuerbarer Energien genügen.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, " Wer wird gefördert? ", -1))

import FontAwesomeList from '@/components/FontAwesomeList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotovoltaikSupport',
  setup(__props) {

const { ioappConfig } = window;

const backgroundImage = `url(${ioappConfig.pluginUri}public/img/Foerderung.jpg)`;

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BaseSpacer),
    _hoisted_3,
    _createVNode(_component_BaseSpacer, { size: "s" }),
    _hoisted_4,
    _hoisted_5,
    _createVNode(FontAwesomeList, { items: [
        'Photovoltaik-Anlagen auf Dächern, an Fassaden oder auf Freiflächen',
        'Anlagen zur Stromerzeugung aus Wasserkraft bis zu einer Größe von 20 MW',
        'Anlagen zur Stromerzeugung aus Windkraft',
        'Anlagen zur Strom- und Wärmeerzeugung in Kraft-Wärme-Kopplungsanlagen auf der Basis von fester Biomasse, Biogas oder Erdwärme',
        'Anlagen zur Erzeugung, Aufbereitung und Einspeisung von Biogas, Biogasleitungen Batteriespeicher'
      ] }),
    _createVNode(_component_BaseSpacer),
    _hoisted_6,
    _createVNode(FontAwesomeList, {
      items: [
          'In- und ausländische private und öffentliche Unternehmen – unabhängig von der Größe',
          'Sie müssen zumindest einen Teil des erzeugten Stroms oder der erzeugten Wärme einspeisen.',
          'Körperschaften und Anstalten des öffentlichen Rechts, kommunale Zweckverbände',
          'Genossenschaften, Stiftungen und Vereine',
          'Privatpersonen und gemeinnützige Antrag­steller',
          'Freiberufler',
          null,
          'Landwirte',
        ],
      "multi-column": ""
    }, null, 8, ["items"]),
    _createVNode(_component_BaseSpacer),
    _createElementVNode("div", {
      class: "card-image-bottom",
      style: _normalizeStyle({ backgroundImage: backgroundImage })
    }, null, 4)
  ]))
}
}

})